import { useEffect } from 'react';

import {
  ExclamationMarkHexagonIcon,
  InformationCircleIcon,
  ThumbUpOutlineIcon,
  ExclamationMarkTriangleOutlineIcon,
} from '@grupoboticario/flora-react-icons';
import { app } from 'core';
import { ResponsiveFloraTypography } from 'ui/components';

import { iconMap } from './iconMap';
import { NotificationStyles } from './Notification.styles';

type StatusToastFlora = 'success' | 'error' | 'alert' | 'neutral';

export const ToastIcons = {
  error: <ExclamationMarkHexagonIcon size="24" />,
  info: <InformationCircleIcon size="24" />,
  success: <ThumbUpOutlineIcon size="24" />,
  warning: <ExclamationMarkTriangleOutlineIcon size="24" />,
};

const NotificationContainer = () => {
  const notifications = app.hooks.useApp('notifications');
  const { hideNotifications } = app.commands.useAppCommand();

  const getStatusColor = (status: string): StatusToastFlora => {
    if (status === 'warning') {
      return 'alert';
    } else if (status === 'info') {
      return 'neutral';
    }

    return status as StatusToastFlora;
  };

  useEffect(() => {
    notifications.forEach((notification) => {
      setTimeout(() => {
        if (notification.id) {
          hideNotifications(notification.id);
        }
      }, notification.timeout ?? 5000);
    });
  }, [notifications]);

  if (notifications.length) {
    return (
      <>
        {notifications.map((notification) => {
          const toastIconStatus =
            iconMap[notification.icon ?? ''] ?? ToastIcons[notification.status ?? 'info'];
          return (
            <NotificationStyles.Wrapper
              data-position={notification.position ?? 'top-center'}
              key={notification.id}
            >
              <NotificationStyles.Toast
                variant={getStatusColor(notification.status as string)}
                duration={notification.timeout ?? 5000}
                data-position={notification.position ?? 'top-center'}
                onClick={() => hideNotifications(notification.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {notification.showIcon && toastIconStatus}
                  <ResponsiveFloraTypography
                    style={{ marginLeft: '10px' }}
                    fontSize="bodySmallStandard"
                    data-testid="notification-message"
                  >
                    {notification.message}
                  </ResponsiveFloraTypography>
                </div>
              </NotificationStyles.Toast>
            </NotificationStyles.Wrapper>
          );
        })}
      </>
    );
  }
  return <></>;
};

export default NotificationContainer;
